import { action as apiAction } from 'api/Api'

type Payload = {
  id: number
}

export default (payload: Payload) => async () => {
  const { id } = payload

  await apiAction('RemoveLabel', {
    labelId: id
  })
}
